import * as React from "react";
import type { SVGProps } from "react";
const BreadcrumbIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4}
    height={4}
    fill="none"
    {...props}
  >
    <circle cx={2} cy={2} r={2} fill="#A6D394" />
  </svg>
);
export default BreadcrumbIcon;